import { ArrowUpRight, MessageSquare } from "lucide-react";
import { insights } from "@/data/insights";

export default function DigtekInsights() {
    const posts = insights.slice(0, 4);

    return (
        <section
            id="insights"
            data-testid="digtek-insights"
            className="relative py-24 lg:py-32 bg-digtek-bg overflow-hidden"
        >
            <div className="digtek-blob purple w-[380px] h-[380px] -left-24 top-24 opacity-40" />

            <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 items-end gap-6 mb-14">
                    <div className="lg:col-span-8">
                        <div className="digtek-eyebrow mb-4">
                            <span>Blog & news</span>
                        </div>
                        <h2
                            data-testid="insights-heading"
                            className="font-display font-bold text-[40px] sm:text-[52px] lg:text-[62px] leading-[1.02] text-digtek-header"
                        >
                            Use insight to{" "}
                            <em className="not-italic text-digtek-purple">
                                drive growth
                            </em>{" "}
                            at your business.
                        </h2>
                    </div>
                    <div className="lg:col-span-4 flex lg:justify-end">
                        <a
                            href="/#insights"
                            data-testid="insights-cta"
                            className="btn-digtek"
                        >
                            All articles
                            <ArrowUpRight className="w-4 h-4" />
                        </a>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {posts.map((p, i) => (
                        <a
                            key={p.slug}
                            href={`/insights/${p.slug}`}
                            data-testid={`insight-card-${i}`}
                            className="group relative bg-white rounded-3xl overflow-hidden border border-digtek-border hover:shadow-[0_30px_60px_-20px_rgba(23,1,44,.2)] transition-all hover:-translate-y-2"
                        >
                            <div className="relative aspect-[4/3] overflow-hidden">
                                <div className="absolute inset-0 bg-gradient-to-br from-digtek-purple to-digtek-header opacity-90 flex items-center justify-center">
                                    <p className="font-display font-bold text-6xl text-digtek-lime">
                                        {p.n}
                                    </p>
                                </div>
                                <span className="absolute top-4 left-4 bg-digtek-lime text-digtek-header text-[11px] uppercase tracking-wider font-bold px-3 py-1.5 rounded-full">
                                    {p.category}
                                </span>
                            </div>
                            <div className="p-6">
                                <div className="flex items-center gap-4 text-xs text-digtek-text mb-3">
                                    <span className="flex items-center gap-1.5">
                                        <MessageSquare className="w-3.5 h-3.5" />
                                        0 comments
                                    </span>
                                    <span>·</span>
                                    <span>{p.date}</span>
                                </div>
                                <h3 className="font-display font-bold text-xl leading-snug text-digtek-header group-hover:text-digtek-purple transition-colors mb-4">
                                    {p.title}
                                </h3>
                                <span className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-digtek-purple group-hover:text-digtek-header">
                                    Read more
                                    <ArrowUpRight className="w-4 h-4" />
                                </span>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}
